import { useContext, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { CardContractUpload } from './ui'
import { ICardContractUpload, ICardContractUploadContainer } from './types'

import { useValue } from '@hooks/useValue'

import { useDict } from '@api/dict/state'
import { IContractSectionsList } from '@api/dict/state.types'

import { NotificationContext, notifyOpen } from '@ui/notification/notification.provider'


/** Контейнер окна загрзки файлов по договору */
export const CardContractUploadContainer = ({isOpen, fileUploader, handlerButtonCancel}: ICardContractUploadContainer) => {
    const notify = useContext(NotificationContext)

    const {isLoading, actionGetContractSections} = useDict(useShallow((state) => state))

    const sectionList = useValue<IContractSectionsList[]>([])
    const selectedSectionID = useValue<number | ''>('')


    useEffect(() => {
        if (isOpen) {
            actionGetContractSections().then((res) => {
                if (res) sectionList.setValue(res)
            })
        }

        !isOpen && clearData()
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    /** Очистка формы */
    const clearData = () => {
        sectionList.setValue([])
        selectedSectionID.setValue('')
    }

    /** Загрузка файлов */
    const thisFileUploader = (files: File[]) => {
        if (!selectedSectionID.value) return notify && notifyOpen('Вы не выбрали раздел из списка.', 'info', 1500, notify)

        fileUploader && fileUploader(files, selectedSectionID.value)
    }

    /** Свойства передаваемые в компоненту */
    const propsToComponent: ICardContractUpload = {
        isOpen, handlerButtonCancel, thisFileUploader,
        isLoading, sectionList, selectedSectionID,
    }

    return <>
        <CardContractUpload {...propsToComponent} />
    </>
}